module.exports = __webpack_public_path__ + "img/2left-n-b7947ce9.png";